import api from 'app/api';
import { format } from 'date-fns';
import { getAnalytics, logEvent } from 'firebase/analytics';

const createImageId = async (image, tag, fileName, loaderId = 'create-image') => {
  const response = await api.post(
    `/image`,
    {
      image,
      fileName,
      tag,
    },
    {
      id: loaderId,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response;
};

const updateImageId = async (id, image, tag, loaderId = 'update-image') => {
  const imagePath = new URL(id).pathname.split('/').pop();
  const response = await api.put(
    `/image/${imagePath}?tag=${tag}`,
    {
      image,
    },
    {
      id: loaderId,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response;
};

const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]), 
    n = bstr.length, 
    u8arr = new Uint8Array(n);
  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
};

const hasElementOverflown = (element) => (
  element?.scrollHeight > element?.clientHeight || element?.scrollWidth > element?.clientWidth
);

const convertISOToCustomDateFormat = (isoString) => {
  const date = new Date(isoString);

  return format(date, 'yyyy-MM-dd HH:mm:ss');
}

const convertCustomDateFormatToISO = (dateString = new Date()) => {
  // Assuming the date string is in the format "YYYY-MM-DD HH:MM:SS"
  if (dateString instanceof Date) return new Date(dateString);

  // const [datePart, timePart] = dateString.split(' ');
  // const [year, month, day] = datePart.split('-');
  // const [hours, minutes, seconds] = timePart.split(':');

  // Constructing the date object
  const date = new Date(dateString);

  return date;
}

const generateUniqueId = (length = 10) => {
  const timestamp = Date.now().toString(36);
  const randomChars = Math.random().toString(36).substr(2, length);
  const uniqueId = timestamp + randomChars;

  return uniqueId;
};

const isValidURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

const analyticEventLogger = (eventName, eventData = {}) => {
  const analytics = getAnalytics();
  try {
    if (process.env.appConfig.env === 'prod'){
      logEvent(analytics, eventName, { ...eventData, env: process.env.env });
    }
  } catch (err) {
    console.log(err);
  }
}

const getBase64 = (arr) => {
  const modifiedArr = new Uint8Array(arr);
  const url = btoa(
     modifiedArr.reduce((data, byte) => data + String.fromCharCode(byte), '')
  );

  return `data:image/svg+xml;base64, ${url}`;
}

const onShareWhatsapp = (number, text) => {
  const encodedText = encodeURIComponent(text);
  const phone = number ? `91${number}` : '';
  const appUrl = `whatsapp://send?phone=${phone}&text=${encodedText}`;
  const webUrl = `https://wa.me/${phone}?text=${encodedText}`;

  const userAgent = window.navigator.userAgent.toLowerCase();
  const isMobile = /iphone|ipad|android/.test(userAgent);

  if (isMobile) {
    // Try to open the app, fallback to web
    window.location.href = appUrl;
    setTimeout(() => {
      window.open(webUrl, '_blank');
    }, 500);
  } else {
    // Only open the web link on desktop
    window.open(webUrl, '_blank');
  }
};

const isDigits = (string = '') => /^\d+$/.test(string);

const camelToSnakeCase = (str) => {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

const getValueByPath = (obj = {}, path = '') => {
  return path.split('.').reduce((acc, part) => {
    return acc?.[part];
  }, obj);
}

export {
  createImageId,
  updateImageId,
  dataURLtoFile,
  hasElementOverflown,
  convertCustomDateFormatToISO,
  convertISOToCustomDateFormat,
  generateUniqueId,
  isValidURL,
  analyticEventLogger,
  getBase64,
  onShareWhatsapp,
  isDigits,
  camelToSnakeCase,
  getValueByPath,
};
